// ─────────────────────────────────────────────────────────────────────────────
// REVA Sidebar — V1.0 PILOT LAUNCH MODE.
//
// Exactly the 11 customer-facing modules approved for pilot launch:
//   Dashboard · Decision Center · Properties · Units · Tenants · Leases ·
//   Payments · Documents · Smart Upload · Team · Settings
//
// Everything else (Maintenance · Tasks · Marketplace · Inspections · Marketing ·
// Community · Readiness · Tenant Onboarding · AI Insights · Insights · Video
// Studio · Digital Twin · Portals · Platform admin) is kept in code (still
// reachable for power-users via direct URL gated by BetaGuard, and remains
// available to Platform Owner) but does NOT appear in the customer navigation.
//
// To revert: replace this file's exports with the previous full IA when V1.5
// modules clear pilot validation.
//
// CONTRACT:
//   • Each submenu path is UNIQUE (uses query params for distinct angles on
//     same route) — protects against multi-highlight in Layout.jsx.
//   • Default state: sidebar is COLLAPSED (rail mode, ~64px wide, icons only).
//   • Click chevron at top → expand to ~256px (inline tree).
//   • Active group/item highlighted ONCE.
// ─────────────────────────────────────────────────────────────────────────────
export const SIDEBAR_IA = (isAr) => [
  {
    id: 'dashboard',
    perm: 'dashboard',
    icon: 'LayoutDashboard',
    label_en: 'Dashboard',
    label_ar: 'لوحة القيادة',
    path: '/dashboard',
    implemented: true,
    submenu: [
      { en: 'Executive dashboard', ar: 'لوحة تنفيذيّة', path: '/dashboard',                 implemented: true },
      { en: 'Decision Center',     ar: 'مركز القرار',  path: '/decisions',                  implemented: true },
    ],
  },
  {
    id: 'portfolio',
    perm: 'properties',
    icon: 'Building2',
    label_en: 'Portfolio',
    label_ar: 'المحفظة',
    path: '/properties',
    implemented: true,
    submenu: [
      { en: 'Properties', ar: 'العقارات', path: '/properties', implemented: true },
      { en: 'Units',      ar: 'الوحدات',  path: '/units',      implemented: true },
    ],
  },
  {
    id: 'leasing',
    perm: 'leases',
    icon: 'FileText',
    label_en: 'Leasing',
    label_ar: 'التأجير',
    path: '/leases',
    implemented: true,
    submenu: [
      { en: 'Tenants',           ar: 'المستأجرون',    path: '/tenants',           implemented: true },
      { en: 'Lease management',  ar: 'إدارة العقود',  path: '/leases',            implemented: true },
    ],
  },
  {
    id: 'finance',
    perm: 'payments',
    icon: 'Wallet',
    label_en: 'Finance',
    label_ar: 'الإدارة المالية',
    path: '/payments',
    implemented: true,
    submenu: [
      { en: 'Rent collection', ar: 'تحصيل الإيجارات', path: '/payments', implemented: true },
    ],
  },
  {
    id: 'files',
    perm: 'documents',
    icon: 'Folder',
    label_en: 'Documents',
    label_ar: 'الوثائق',
    path: '/documents',
    implemented: true,
    submenu: [
      { en: 'All documents', ar: 'جميع الوثائق', path: '/documents',    implemented: true },
      { en: 'Smart upload',  ar: 'رفع ذكي',     path: '/smart-upload', implemented: true },
    ],
  },
];

export const SIDEBAR_ADMIN = (isAr) => [
  { perm: 'team',     icon: 'Users', label_en: 'Team',     label_ar: 'الفريق',   path: '/team',     implemented: true },
  { perm: 'settings', icon: 'Cog',   label_en: 'Settings', label_ar: 'الإعدادات', path: '/settings', implemented: true },
  // Platform Owner only — gated by perm, hidden from regular customers
  { perm: 'platform', icon: 'Crown', label_en: 'Platform Owner', label_ar: 'مالك المنصّة', path: '/platform',   implemented: true },
];
